import { Card, Chip, Container, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { NextSeo } from 'next-seo'
import React from 'react'
import dynamic from 'next/dynamic'
import { Amplitude, LogOnMount } from '@amplitude/react-amplitude'

import Background from '../src/components/Subnav/Background'
import { urls } from '../src/utils/config'
import Nav from '../src/components/Nav'
import Footer from '../src/components/Footer'
const Mailchimp = dynamic(() => import('../src/components/Mailchimp/etoro'))

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: 0,
  },
  subContainer: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  leftContainer: {
    margin: '50px 0 0 75px',
    width: '50%',
    [theme.breakpoints.down('xs')]: {
      padding: '10px 20px',
      margin: '0',
      width: '100%',
    },
  },
  rightContainer: {
    width: '50%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: '10px 20px',
      margin: '0',
      width: '100%',
    },
  },
  error: {
    padding: '50px',
    margin: '50px',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
    maxHeight: '600px',
    objectFit: 'contain',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  title: {
    color: 'white',
    marginTop: '20px',
  },
  subtitle: {
    color: 'white',
    marginTop: '20px',
    [theme.breakpoints.down('xs')]: {
      // display: 'none',
    },
  },
  chip: {},
  benefits: {
    margin: 'auto 50px',
    padding: '75px 0',
    textAlign: 'center',
  },
  cards: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  card: {
    width: '330px',
    height: '230px',
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '20px',
    textAlign: 'center',
  },
  cardImage: {
    width: '120px',
    height: '120px',
    objectFit: 'contain',
  },
  cardTitle: {
    marginTop: '20px',
  },
  brandContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
    },
  },
  etoroLogo: {
    maxHeight: '40px',
    width: 'auto',
    objectFit: 'contain',
    [theme.breakpoints.down('xs')]: {
      maxHeight: '30px',
    },
  },
  bullets: {
    color: '#ccc',
    marginTop: '10px',
  },
}))

function EtoroDeal(): JSX.Element {
  const classes = useStyles({})

  return (
    <Amplitude
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      eventProperties={(inheritedProps: { page: any }) => ({
        ...inheritedProps,
        page: {
          ...inheritedProps.page,
          name: urls.etoro,
        },
      })}
    >
      {(): JSX.Element => (
        <>
          <LogOnMount eventType="page-displayed" />
          <NextSeo
            title={`Cryptotesters.com - eToro exclusive deal`}
            description={`Cryptotesters.com + eToro - 75$ sign-up bonus!`}
            openGraph={{
              url: `https://cryptotesters.com`,
              title: `Cryptotesters.com - eToro exclusive deal`,
              description: `Cryptotesters.com + eToro - 75$ sign-up bonus!`,
              images: [
                {
                  url: 'https://cryptotesters.com/sharing.png',
                  width: 145,
                  height: 56,
                  alt: `Cryptotesters.com`,
                },
              ],
              site_name: 'Cryptotesters.com',
            }}
            twitter={{
              handle: '@cryptotesters',
              site: '@cryptotesters',
              cardType: 'summary_large_image',
            }}
          />
          <Nav />
          <Container className={classes.root}>
            <Background size="xxl" />
            <div className={classes.subContainer}>
              <div className={classes.leftContainer}>
                <div className={classes.brandContainer}>
                  <Chip label="Enjoy our Exclusive Deal with eToro" className={classes.chip} />
                  <img
                    width={130}
                    height={40}
                    src="/svg/etoro-logo.svg"
                    className={classes.etoroLogo}
                  />
                </div>
                <Typography variant="h4" className={classes.title}>
                  Get $50 when you sign-up with eToro &amp; complete one trade
                </Typography>
                <Typography variant="body2" className={classes.bullets}>
                  - The bonus is paid out by us - not eToro <br /> - The offer only applicable to US
                  citizens
                </Typography>
                <Typography variant="body2" className={classes.subtitle}>
                  eToro is the world’s leading social trading platform, trusted by millions of users
                  from more than 140 countries. The eToro platform offers a variety of assets to
                  trade and invest.
                </Typography>
                <div>
                  <Mailchimp />
                </div>
              </div>
              <div className={classes.rightContainer}>
                <div className={classes.image}>
                  <img width={300} height={600} src="/etoro-phone.png" />
                </div>
              </div>
            </div>
            <div className={classes.benefits}>
              <Typography variant="h6">
                Join eToro today and start discovering a wide variety of benefits, on mobile or web
                platform:
              </Typography>
              <div className={classes.cards}>
                <Card className={classes.card}>
                  <img
                    height={120}
                    width={120}
                    src="/svg/etoro-social.svg"
                    className={classes.cardImage}
                  />
                  <Typography variant="body2" className={classes.cardTitle}>
                    2,000+ assets
                  </Typography>
                </Card>
                <Card className={classes.card}>
                  <img
                    height={120}
                    width={120}
                    src="/svg/etoro-money.svg"
                    className={classes.cardImage}
                  />
                  <Typography variant="body2" className={classes.cardTitle}>
                    Low and transparent fees
                  </Typography>
                </Card>
                <Card className={classes.card}>
                  <img
                    height={120}
                    width={120}
                    src="/svg/etoro-network.svg"
                    className={classes.cardImage}
                  />
                  <Typography variant="body2" className={classes.cardTitle}>
                    Feature for novices and experts
                  </Typography>
                </Card>
                <Card className={classes.card}>
                  <img
                    height={120}
                    width={120}
                    src="/svg/etoro-family.svg"
                    className={classes.cardImage}
                  />
                  <Typography variant="body2" className={classes.cardTitle}>
                    Wisdom of the crowd via social trading
                  </Typography>
                </Card>
                <Card className={classes.card}>
                  <img
                    height={120}
                    width={120}
                    src="/svg/etoro-graphs.svg"
                    className={classes.cardImage}
                  />
                  <Typography variant="body2" className={classes.cardTitle}>
                    Read-made CopyPorfolios &#x2122;
                  </Typography>
                </Card>
                <Card className={classes.card}>
                  <img
                    height={120}
                    width={120}
                    src="/svg/etoro-computer.svg"
                    className={classes.cardImage}
                  />
                  <Typography variant="body2" className={classes.cardTitle}>
                    Intuitive, easy-to-use platforms
                  </Typography>
                </Card>
              </div>
            </div>
          </Container>
          <Footer />
        </>
      )}
    </Amplitude>
  )
}

export default EtoroDeal
